import { OFFERS_IMAGES } from '../../../../../LoyaltySummary/assets/images';
import { Flex, Text } from '../../../../../ui-kit';
import theme from '../../../../../ui-kit/themes/theme';
import { editCopyByReplaceWithComponent } from '../../../../../utilities/copyFunctions';
import { handlePointsBalance } from '../../../../../utilities/utils';
import { SummaryContent } from '../../../Content';
import * as COPY from '../../utilities/copy';
import { OfferImageContainer, PointsContainer } from '../styles';

const Points = ({
  showLoyalty,
  loyaltyOptIn,
  pointAmount,
  suiteTotal,
  userOffers,
  activeOffers,
  isCartVariation,
  shouldSavePoints,
  pointsBalance
}) => {
  const pointsBalanceAmount = handlePointsBalance(
    showLoyalty,
    loyaltyOptIn,
    pointAmount,
    suiteTotal,
    userOffers,
    activeOffers
  );

  const pointsBalanceTotal = handlePointsBalance(
    showLoyalty,
    loyaltyOptIn,
    pointsBalance,
    suiteTotal,
    userOffers,
    activeOffers
  );

  const pointsBalanceValue = () => {
    const value = shouldSavePoints ? pointsBalanceAmount : pointsBalanceTotal;
    const formattedValue = shouldSavePoints ? `$${value.toFixed(2)}` : value.toFixed(0);
    return <strong>{formattedValue}</strong>;
  };

  const shouldSavePointsColor = isCartVariation ? theme.colors.voyagersGreen : theme.colors.deepForestGreen[100];

  return (
    <PointsContainer isCartVariation={isCartVariation}>
      {!isCartVariation ? <SummaryContent.Divider /> : null}
      <SummaryContent.Description>
        <Flex flexDirection="row" justifyContent="space-between" width={1}>
          <Flex>
            <OfferImageContainer mr="8px">
              <img src={OFFERS_IMAGES.VOYAGER_ICON_FOREST_GREEN} alt="" />
            </OfferImageContainer>
            <Text my="0" fontSize={0} color={shouldSavePointsColor} fontWeight="medium" lineHeight={'150%'}>
              {editCopyByReplaceWithComponent(
                shouldSavePoints ? COPY.POINTS_AVAILABLE : COPY.POINTS_APPLIED,
                pointsBalanceValue(),
                '<POINTS>'
              )}
            </Text>
          </Flex>
          <Text fontSize={0} color={shouldSavePointsColor} fontWeight="bold" lineHeight={'150%'} caps>
            {shouldSavePoints ? 'available' : `-$${pointsBalanceAmount.toFixed(2)}`}
          </Text>
        </Flex>
      </SummaryContent.Description>
      {shouldSavePoints ? (
        <Text color={shouldSavePointsColor} fontSize={[9, 9, 9, 0]} fontWeight="medium" lineHeight="150%">
          {COPY.POINTS_AVAILABLE_FOR_LATER}
        </Text>
      ) : null}
    </PointsContainer>
  );
};

export default Points;
